import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { FormattedMessage } from 'react-intl';
import { getContentBlockItemsByName, getContentBlockMixedItems, getContentBlockMixedItem, getContentBlockByName, getContentBlockItemByName, getContentBlockItemValue } from '../../../Cms/CmsActions.js';

import Icon from '../../../../components/Content/Icon.js';
import CmsBlockItem from '../../../Cms/components/content/CmsBlockItem.js';
import PredictiveLink from '../../../Cms/components/view/PredictiveLink.js';

function PanelMainMenu({ panel, isMobile = false, closeMenu = null }) {
    const [isOpen, toggle] = useState(false);
	const title = getContentBlockItemValue(panel.blocks, 'title');
    const links = getContentBlockItemsByName(panel.blocks, 'links');
	// getContentBlockMixedItem(link, 'mainLevel').path

    if(links && links.length) {
        return (
            <div className={classnames('main-menu', 'position-relative', isMobile && ['mt-4', 'mobile'], isOpen && 'open')}>
				<div className="main-menu-title mb-2 pb-2 d-flex justify-content-between">
					<span className="text-uppercase text-danger display-9 "><Icon icon="menu-left" /> {title}</span>
					{closeMenu && (
						<span className="me-4 mt-1 text-uppercase" onClick={closeMenu}>
							<FormattedMessage id="close" defaultMessage="Close" />
							<Icon icon="close" size="8x" className="ms-2 active" style={{ marginTop: '-5px' }} />
						</span>
					)}
				</div>
				<Row className="gx-5 gx-md-3 gx-lg-1 gy-3">
					{links.filter(link => getContentBlockMixedItem(link, 'mainLevel') && getContentBlockMixedItem(link, 'mainLevel').path).map((link, index) => (
						<Col key={index} xs={6} md="4" xl={2} className="sub-menu">
							{
								getContentBlockMixedItems(link, 'subLevel') && getContentBlockMixedItems(link, 'subLevel').length
								? (
									<Fragment key={index}>
										<span className="sub-category-title d-flex justify-content-between mb-1 ms-lg-2 border-half-dangerlight text-sm text-uppercase text-decoration-none" style={{ fontSize: '0.8rem' }}>
											<PredictiveLink tag="a" href={getContentBlockMixedItem(link, 'mainLevel').path} className="text-sm text-danger text-decoration-none">{getContentBlockMixedItem(link, 'mainLevel').text}</PredictiveLink>
											{/* <CmsBlockItem item={getContentBlockMixedItem(link, 'mainLevel')} type="link" /> */}
										</span>
										<ul className="ms-3 mb-0 list-unstyled">
											{getContentBlockMixedItems(link, 'subLevel').map(sub => (
												<li key={sub.path} className="mb-1 mb-md-0"><PredictiveLink tag="a" href={sub.path} className="text-decoration-none" usePrefetch onClick={closeMenu}>{sub.text}</PredictiveLink></li>
											))}
										</ul>
									</Fragment>
								)
								: <CmsBlockItem key={index} item={getContentBlockMixedItem(link, 'mainLevel')} type="link" />
							}
						</Col>
					))}
				</Row>
            </div>
        );
    }
    return null;
}
// <Nav>
//     {links.filter(link => getContentBlockMixedItem(link, 'mainLevel') && getContentBlockMixedItem(link, 'mainLevel').path).map((link, index) => (
//         <li key={index}>
//             {
//                 getContentBlockMixedItems(link, 'subLevel') && getContentBlockMixedItems(link, 'subLevel').length
//                 ? (
//                     <UncontrolledDropdown>
//                         <DropdownToggle caret tag={Link} to="#" onClick={event => event.preventDefault()} className={classnames(isOpen && ['border-bottom-warning', 'open'])}>
//                             {getContentBlockMixedItem(link, 'mainLevel').text}
//                         </DropdownToggle>
//                         <DropdownMenu className="general-submenu">
//                             {getContentBlockMixedItems(link, 'subLevel').map(sub => <DropdownItem key={sub.path} tag={Link} to={sub.path} className="text-dark">{sub.text}</DropdownItem>)}
//                         </DropdownMenu>
//                     </UncontrolledDropdown>
//                 )
//                 : <NavItem><CmsBlockItem item={getContentBlockMixedItem(link, 'mainLevel')} type="link" /></NavItem>
//             }
//         </li>
//     ))}
// </Nav>

//      <!-- This checkbox will give us the toggle behavior, it will be hidden, but functional -->
//     <input id="toggle" type="checkbox">
//
//     <!-- IMPORTANT: Any element that we want to modify when the checkbox state changes go here, being "sibling" of the checkbox element -->
//
//     <!-- This label is tied to the checkbox, and it will contain the toggle "buttons" -->
//     <label class="toggle-container" for="toggle">
//         <!-- If menu is open, it will be the "X" icon, otherwise just a clickable area behind the hamburger menu icon -->
//         <span class="button button-toggle"></span>
//     </label>
//
//     <!-- The nav menu -->
//     <nav class="nav">
//         <a class="nav-item" href="">Dashboard</a>
//         <a class="nav-item" href="">History</a>
//         <a class="nav-item" href="">Statistics</a>
//         <a class="nav-item" href="">Settings</a>
//     </nav>
//

PanelMainMenu.propTypes = {
    panel: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    closeMenu: PropTypes.func,
};

export default PanelMainMenu;
